/* eslint-disable @typescript-eslint/no-empty-function */
import React, { createContext, useState } from "react";
import { ContextStatus } from '@leedpulse-monorepo/enums';
import getInfo, { InfoResponse } from "../../../domain/use_cases/app/getInfo";

const AppContext = createContext({
  item: null as InfoResponse | null,
  status: ContextStatus.IDLE,
  fetch: () => { },
  reset: () => { },
});

export const AppProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const [item, setItem] = useState(null as InfoResponse | null);

  const [status, setStatus] = useState(ContextStatus.IDLE);

  const fetch = async () => {
    setStatus(ContextStatus.LOADING);
    try {
      const useCaseResponse = await getInfo();
      if (useCaseResponse) {
        setItem(useCaseResponse);
        setStatus(ContextStatus.SUCCESS);
      } else {
        setStatus(ContextStatus.ERROR);
      }
      setStatus(ContextStatus.SUCCESS);
    } catch (e) {
      setStatus(ContextStatus.ERROR);
    }
  };

  const reset = () => {
    setItem(null);
    setStatus(ContextStatus.IDLE);
  };

  return (
    <AppContext.Provider
      value={{
        item,
        status,
        fetch,
        reset,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export default AppContext;
